module.exports = __webpack_public_path__ + "img/icon4.fe3ed522.png";